


























































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import Customer from "@/types/customer/Customer";
import getters from "@/store/modules/customer/getters";

import CustomerInvestmentHeader from "@/components/headers/customer-investment";

import Header from "@/types/app/header";
import Investment, { investmentInitialValue } from "@/types/app/investment";

import Endpoint from "@/utils/endpoint";
import formatMoney from "@/utils/formatMoney";
import formatDate from "@/utils/formatDate";
import applyCondition from "@/utils/applyCondition";
import ModalInvestment from "@/components/common/ModalInvestment.vue";
import ModalSuccess from "@/components/common/ModalSuccess.vue";
import BaseComponent from "@/utils/baseComponent";
import RefreshStore from "@/services/refreshStore";
const namespace = "customer";

@Component({
  components: { investment: ModalInvestment, ModalSuccess },
})
export default class DemonstrationOfInterest extends BaseComponent {
  @Getter("getLoading", { namespace }) loading!: boolean;
  @Getter("getCustomers", { namespace }) customers!: Customer[];
  @Getter("getModalInvestmentState", { namespace })
  modalInvestmentState!: boolean;

  @Action("setLoading", { namespace }) setLoading!: any;
  @Action("setInvestmentState", { namespace }) setInvestmentState!: any;
  @Action("setCustomer", { namespace }) setCustomer!: any;
  @Action("setModalInvestmentState", { namespace })
  setModalInvestmentState!: any;

  loadingInvestments = false;

  fullNameFilter = "";
  titleFilter = "";
  statusFilter = "";
  selectedInvestments: any[] = [];
  openSuccessModal = false;
  openSuccessModalMessage = "";

  @Watch("modalInvestmentState")
  refreshInvestments(newValue: boolean) {
    if (newValue) return;
    this.handleInvestments();
  }

  private endpoint = new Endpoint();

  headers: Header[] = CustomerInvestmentHeader.header;
  investments: Investment[] = [];
  formatMoney = formatMoney;
  formatDate = formatDate;

  async mounted() {
    await this.handleInvestments();
  }

  async handleInvestments() {
    this.loadingInvestments = true;
    const investmentEndpoint = this.endpoint.investments;
    const response = await this.$http.get(investmentEndpoint);
    const investments: Investment[] = response.data;
    this.investments = investments;
    this.loadingInvestments = false;
  }

  get hasSelectedInvestments() {
    return this.selectedInvestments.length > 0;
  }

  getLabelNameByStatus(status: number) {
    if (status === 0) {
      return "Pending";
    }
    if (status === 1) {
      return "Documentation";
    }
    if (status === 2) {
      return "Finalized";
    }

    return "Unknown Status";
  }

  get filteredInvestments() {
    const conditions: any[] = [];
    if (this.titleFilter) {
      conditions.push((item: Investment) =>
        item.title.toLowerCase().includes(this.titleFilter.toLowerCase())
      );
    }

    if (this.statusFilter) {
      conditions.push((item: Investment) =>
        this.getLabelNameByStatus(item.status)
          .toLowerCase()
          .includes(this.statusFilter.toLowerCase())
      );
    }

    if (this.fullNameFilter) {
      conditions.push((item: Investment) =>
        item.fullName.toString().toLowerCase().includes(this.fullNameFilter.toLowerCase())
      );
    }
    return applyCondition<Investment>(this.investments, conditions);
  }

  getClassNameByStatus(status: number) {
    if (status === 0) {
      return "pending";
    }
    if (status === 1) {
      return "documentation";
    }
    if (status === 2) {
      return "finalized";
    }

    return "unknown";
  }

  setModalInvesment(item: Investment): void {
    this.setInvestmentState(item);
    this.setModalInvestmentState(true);
  }

  deleteInvestments() {
    this.$confirm("Do you really want to delete this select investment(s)?").then(
      (res) => {
        if (res) {
          const url = `${this.endpoint.investments}`;
          const myInterests = this.selectedInvestments.map((x) => x.id);
          this.loadingInvestments = true;
          this.$http
            .delete(`${url}`, { data: { myInterests } })
            .then((res: any) => {
              this.investments = this.investments.filter(
                (p) => !myInterests.some((m) => m == p.id)
              );

              this.openSuccessModalMessage = "Deleted investment(s) with success!";
              this.openSuccessModal = true;
              this.loadingInvestments = false;
            })
            .catch((err) => {
              this.loadingInvestments = false;
              console.error(err);
            });
        }
      }
    );
  }

  newInvestments() {
    this.setInvestmentState(investmentInitialValue);
    this.setModalInvestmentState(true);
  }

  async exportCsv() {
    const newArr = this.investments
      .map(({ documents, subDocsFilled, formsField, ...rest }) => {
        return rest;
      })
      .sort(
        (a, b) => new Date(a.dateInterest).getTime() - new Date(b.dateInterest).getTime()
      );
    this.exportCSVFile([...newArr], `Investments-export`);
  }
}
